import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button';
import { TranslationNamespace } from 'i18n';

// P2P providers with useProviderPaymentUrl enabled complete payment on their own hosted page.
// We send the customer there automatically and keep a visible button as a fallback for when the
// auto-redirect is blocked. The once-guard prevents re-firing on polling-driven re-renders.
type Props = {
  paymentLink: string;
};

export const ProviderPaymentRedirect: React.FC<Props> = ({ paymentLink }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.ecom_redirect',
  });
  const redirectAttemptedRef = useRef(false);

  useEffect(() => {
    if (redirectAttemptedRef.current) {
      return;
    }
    redirectAttemptedRef.current = true;
    window.location.assign(paymentLink);
  }, [paymentLink]);

  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-3 md:tw-gap-4">
      <h3 className="tw-text-lg tw-font-bold tw-text-primary md:tw-text-2xl">
        {t('title')}
      </h3>
      <p className="tw-text-secondary">{t('hint')}</p>
      <Button
        className="tw-mt-2"
        onClick={() => window.location.assign(paymentLink)}
      >
        {t('submit')}
      </Button>
    </div>
  );
};
